// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Franquias_SalvarWizardInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /franquias/salvarWizard/{franquia_id}
 *
 * Saves franchise configuration wizard data (operational, financial, fiscal, unit settings).
 */
import { registerContract } from './validate'

export interface Franquias_SalvarWizardInput {
capacidade_producao_diaria?: number
meta_producao_itens_dia?: number
valor_medio_item?: string
investimento_total?: string
roe_desejado?: string
cnpj?: string
inscricao_estadual?: string
endereco?: string
numero?: string
complemento?: string
bairro?: string
cidade?: string
estado?: string
cep?: string
mensagem_aniversariante?: string
mensagem_boas_vindas?: string
abre_sabado?: number
abre_domingo?: number
dias_uteis_padrao?: number
}

registerContract('Franquias_SalvarWizardInput', {
  capacidade_producao_diaria: { type: 'number',  required: false },
  meta_producao_itens_dia:    { type: 'number',  required: false },
  valor_medio_item:           { type: 'string',  required: false },
  investimento_total:         { type: 'string',  required: false },
  roe_desejado:               { type: 'string',  required: false },
  cnpj:                       { type: 'string',  required: false },
  inscricao_estadual:         { type: 'string',  required: false },
  endereco:                   { type: 'string',  required: false },
  numero:                     { type: 'string',  required: false },
  complemento:                { type: 'string',  required: false },
  bairro:                     { type: 'string',  required: false },
  cidade:                     { type: 'string',  required: false },
  estado:                     { type: 'string',  required: false },
  cep:                        { type: 'string',  required: false },
  mensagem_aniversariante:    { type: 'string',  required: false },
  mensagem_boas_vindas:       { type: 'string',  required: false },
  abre_sabado:                { type: 'number',  required: false },
  abre_domingo:               { type: 'number',  required: false },
  dias_uteis_padrao:          { type: 'number',  required: false },
})
